import React, { useState, useEffect } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import CustomTable from "../../organisms/CustomTable";
import CardContainer from "./CardContainer";
import { getAverageBidPrice } from "../../../utils/API/averagebidprice";
import toast from "react-hot-toast";
import { formatBalance } from "../../../utils/helper/wallet";
import { useDispatch } from "react-redux";

const ReBiddingDialog = ({
  title,
  open,
  onCancel,
  selectedRowData,
  selectedColumns,
  children,
  schemaType,
}) => {
  const [bidPrices, setBidPrices] = useState(null);
  const [error, setError] = useState(null);
  const reduxDispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const data = await getAverageBidPrice({reduxDispatch});
        if (isMounted) {
          setBidPrices(data);
        }
      } catch (err) {
        setError(err.message);
        toast.error("Error fetching bid prices: " + err.message);
      }
    };

    if (open) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, [open]);

  let bodyData;
  let headerData;

  if (selectedRowData && selectedColumns) {
    bodyData = [selectedColumns.map((column) => selectedRowData[column])];
    headerData = selectedColumns;
  } else {
    const data = [
      {
        "Project Name": "Forestry",
        "Number Of Credits": "110",
        "Token Category": "Gold",
      },
    ];
    headerData = Object.keys(data[0]);
    bodyData = data.map((listing) => Object.values(listing));
  }

  if (!bodyData || !bidPrices) {
    return null;
  }

  return (
    <DiaglogBox open={open} width={710} onCancel={onCancel} closeIcon={true}>
      <div className="py-2">
        <h3 className="text-3xl font-bold pl-10 text-black w-fit mb-6">
          {title}
        </h3>
        <CustomTable
          data={bodyData}
          headerData={headerData}
          schemaType={schemaType}
        />

        {children}

        <div className="flex gap-x-4 py-3 px-10">
          {error ? (
            <p>{error}</p>
          ) : (
            <>
              <CardContainer variant="gold">
                {bidPrices.data && bidPrices.data.Gold !== undefined
                  ? formatBalance(bidPrices.data.Gold)
                  : "N/A"}
              </CardContainer>
              <CardContainer variant="silver">
                {bidPrices.data && bidPrices.data.Silver !== undefined
                  ? formatBalance(bidPrices.data.Silver)
                  : "N/A"}
              </CardContainer>
              <CardContainer variant="bronze">
                {bidPrices.data && bidPrices.data.Bronze !== undefined
                  ? formatBalance(bidPrices.data.Bronze)
                  : "N/A"}
              </CardContainer>
            </>
          )}
        </div>
      </div>
    </DiaglogBox>
  );
};

export default ReBiddingDialog;
